import React from "react";
import { Input } from "./input";
import { list, listItem, dropdown, spinnerContainer } from "./combobox.css";
import { Text } from "@vagastec/ensemble-core";
import { vars } from "../theme.css";
import { Spinner } from "./spinner";

export function Combobox({
  data = [],
  error = false,
  isLoading = false,
  getItemId = (item) => item.id,
  getItemLabel = (item) => item.label,
  getSelectedItemLabel = (item) => item.label,
  query = "",
  setQuery = () => {},
  onSelectedChange = () => {},
  required,
  errorMessage,
  text = "",
  overlayDataTestId,
  ...rest
}) {
  const [isDropdownOpen, setIsDropdownOpen] = React.useState(false);

  function renderData() {
    if (error) return <p>Error</p>;
    if (isLoading && query.length >= 3)
      return (
        <div className={spinnerContainer} data-testid="dropdownCargo">
          <Spinner />
        </div>
      );
    if (!data.length)
      return (
        <li className={listItem}>
          <Text fontColor={vars.color.foreground}>{text}</Text>
        </li>
      );
    return data.map((item) => (
      // eslint-disable-next-line
      <li
        data-testid="dropdownCargo"
        className={listItem}
        key={getItemId(item)}
        onClick={() => {
          setQuery(getSelectedItemLabel(item));
          setIsDropdownOpen(false);
          onSelectedChange(item);
        }}
      >
        <Text fontColor={vars.color.foreground}>{getItemLabel(item)}</Text>
      </li>
    ));
  }

  function handleKeyUp(e) {
    if (e.code === "Escape") {
      setIsDropdownOpen(false);
    }
  }

  document.addEventListener("keyup", handleKeyUp);

  return (
    <div>
      {isDropdownOpen ? (
        //  eslint-disable-next-line
        <div
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 1,
          }}
          onClick={() => setIsDropdownOpen(false)}
          data-testid={overlayDataTestId}
        />
      ) : null}
      <div
        style={{
          position: "relative",
          zIndex: 2,
        }}
      >
        <Input
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onFocus={() => setIsDropdownOpen(true)}
          style={{ zIndex: 2 }}
          aria-label="cargo"
          required={required}
          errorMessage={errorMessage}
          {...rest}
          // TODO
          // role="combobox"
          // aria-autocomplete="list"
          // aria-controls={}
          // aria-expanded={}
          // id={}
        />

        {query.length ? (
          <>
            {isDropdownOpen ? (
              <div className={dropdown}>
                <ul className={list}>{renderData()}</ul>
              </div>
            ) : null}
          </>
        ) : null}
      </div>
    </div>
  );
}
